import { Component, Input } from '@angular/core';
import * as pkg from '../../../../../package.json';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { HoverMenuesService } from 'src/app/hover-menues/services/hover-menues.service';
import { Router } from '@angular/router';
const { version: extractedVersion } = pkg;

@Component({
  selector: 'app-breadcrumbed-help',
  templateUrl: './breadcrumbed-help.component.html',
  styleUrls: ['./breadcrumbed-help.component.scss'],
})
export class BreadcrumbedHelpComponent {
  @Input() showMenu: boolean;
  @Input() heightReference: any = 0;
  version: string;

  constructor(
    public hoverMenuesService: HoverMenuesService,
    private readonly translateService: TranslateService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {
    this.version = extractedVersion;
  }

  getFilterName = () => {
    const name = this.translateService.instant('AppComponent.Help');
    return this.showMenu ? name : name.slice(0, 1) + '...';
  };

  goToUserManual() {
    this.router.navigate(['/usermanual']);
  }

  onFeedback() {}

  onContactSupport() {}

  calcOffset = () => {
    const isSmallScreen = window.innerWidth <= 1300;

    let sideMenu = 205;
    let noneOpen = 75;

    if (isSmallScreen) {
      sideMenu = 160;
      noneOpen = 65;
    }

    return this.showMenu ? sideMenu : noneOpen;
  };
}
